<template>
   <div>
      <top-header></top-header>
      <main-menu></main-menu>
      <!-- Start the code for this screen here -->
      <div class="pagecontainer  container">
        <div>
    <span class="timercontent" > Elapsed Time {{(minutes<10) ? ("0" +minutes):minutes}}:{{(seconds<10) ? ("0" + seconds) : seconds}}  </span>

<b-tabs  v-model="quoteobject.quote.tabIndex" >
     <b-tab title="Market Value" active>
            <MarketValue :quoteobject="quoteobject" :quoteobject1="quoteobject1"/>
     </b-tab>
    <b-tab title="Financials">
            <InputFinancials  :quoteobject="quoteobject"/>
    </b-tab>
    <b-tab title="Lease Details">
          <LeaseDetails :quoteobject="quoteobject"/>
    </b-tab>
    <b-tab title="Quote">
    <FinalQuote :quoteobject="quoteobject"/>
    </b-tab>
    <b-tab title="Amortization" @click="emitAmortization()">
    <Amortization :quoteobject="quoteobject"/>
    </b-tab>
     <b-tab title="Metrics" @click="emitAmortest()">
     <FinancialMetrics :quoteobject="quoteobject"/>
    </b-tab>
</b-tabs>
</div>
<div>

</div>
      </div>
      <!-- End of the code for this screen here -->
      <bottom-footer></bottom-footer>
   </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import InputMarketValue from '@/components/MarketValue.vue'
import LeaseDetails from '@/components/LeaseDetails.vue'
import DealInputFinancials from '@/components/InputFinancial.vue'
import FinancialMetrics from '@/components/FinancialMetrics.vue'
import Amortization from '@/components/Amortization.vue'
import finalquote from '@/components/Quote.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import MainMenu from '@/components/Menu.vue'
import vuetab from '@/css/vuetab.css'
import generatequoteobject from '@/object/quote.js'
import generatequoteobjects from '@/object/quotes.js'

import { bus } from '../main'
export default {
  components: { MainMenu,
    'MarketValue': InputMarketValue,
    'InputFinancials': DealInputFinancials,
    'FinalQuote': finalquote,
    'FinancialMetrics': FinancialMetrics,
    'Amortization': Amortization,
    'LeaseDetails': LeaseDetails,
    TopHeader,
    BottomFooter
  },
  name: 'GenerateQuote',
  data () {
    return {
      quoteobject: generatequoteobject,
      quoteobject1: generatequoteobjects,

      hours: 0,
      minutes: 0,
      seconds: 0,
      counter: 1
    }
  },
  methods: {
    emitAmortization () {
      bus.$emit('i-got-clicked', 'amort data')
    },
    emitAmortest () {
      bus.$emit('i-got-clicked', 'amort est')
    },
    timer () {
      setInterval(() => {
        this.seconds = this.counter++ % 60
        this.minutes = parseInt(this.counter / 60) % 60
        // this.quoteobject.quotegeneration.hours = parseInt(this.counter / 3600) % 60
        // console.log( this.counter)
      }, 1000)
    },

    fetchdata: function () {
      this.timer()
    }
  },

  mounted: function () {
    this.fetchdata()
  }

}
</script>
<style scoped>
 #column {
  float: left;

  padding: 1px;
}

.timercontent{
      font-family: Verdana, Geneva, Tahoma, sans-serif;
    color:red;
    margin-left:85%;

}
#tabbutton{
    float:right;
    color: white;
    padding: 6px 20px;
    background-color: dodgerblue;
    border: 1px solid #ddd;
    margin: 10px 0px 0px 0px;
}
#marginright{
    margin-right: 10%
}
@media  (max-width: 1100px){
.timercontent{
      font-family: Verdana, Geneva, Tahoma, sans-serif;
    color:red;
    margin-left:80%;

}
 /*.pagecontainer{
    width: 100%;
    float: left;

    height: 2100px;
    overflow: scroll;
}*/
}
@media (max-width: 800px) {
   .timercontent{
      font-family: Verdana, Geneva, Tahoma, sans-serif;
    color:red;
    margin-left:83%;
    font-size:12px;

}
}

</style>
